import React from "react";
import SocialLogin from "react-social-login";

// Social media buttons components
// Shows first social media option for login
class SocialButton2 extends React.Component {
  render() {
    const { children, triggerLogin, ...props } = this.props;
     
    return (
      <>
      <button  onClick={triggerLogin}  {...props}  className={`facebook ${children === undefined ? 'small' : ''} p-button`}>
        {children} 
      </button>
     </>
    );
  }
}

export default SocialLogin(SocialButton2);